import React from "react";
import { DownArrowIcon } from "../../Icons";
import InitialsAvatar from "../../Common/InitialsAvatar";

const BeneficiaryButton = ({ beneficiaryName, accountNumber, iban, virtualBankBeneficiary }) => {
  const formateVirtualBankDetails = (virtualBankBeneficiary) => {

    // Parse routing codes safely
    let routingCodes = virtualBankBeneficiary?.bank_routing_codes;

    if (typeof routingCodes === "string") {
      try {
        const parsed = JSON.parse(routingCodes);

        // normalize single object → array
        routingCodes = Array.isArray(parsed) ? parsed : [parsed];
      } catch (e) {
        routingCodes = [];
      }
    }

    // Normalize keys (backend vs frontend mismatch fix)
    const routingNumber =
      routingCodes?.find(
        (code) =>
          code.routingCodeKey === "ROUTING_NUMBER" ||
          code.type === "routing_number"
      )?.routingCodeValue ||
      routingCodes?.find(
        (code) =>
          code.routingCodeKey === "SORT_CODE" ||
          code.type === "sort_code"
      )?.routingCodeValue;

      return (
        <div className="beneficiary-btn-text-secondary text-xs font-normal">
          Routing Number: {routingNumber}
        </div>
      )
  };

  return (
    <div className="beneficiary-button-wrapper flex cursor-pointer justify-between px-4 py-3 my-3 rounded-3xl border">
      <div className="flex justify-center items-start space-x-3">
        <InitialsAvatar name={beneficiaryName} />
        <div className="flex flex-col space-y-1">
          <div className="beneficiary-btn-text-primary text-sm font-semibold">
            {beneficiaryName}
          </div>
          <div className="beneficiary-btn-text-secondary text-xs font-normal">
            Account: {accountNumber}
          </div>
          {iban && (
            <div className="beneficiary-btn-text-secondary text-xs font-normal">
              IBAN: {iban}
            </div>
          )}
          
          {virtualBankBeneficiary &&
            formateVirtualBankDetails(virtualBankBeneficiary)
          }
          
        </div>
      </div>
      <DownArrowIcon className="-rotate-90" />
    </div>
  );
};

export default BeneficiaryButton;
